/**
 * Dependencies.
 */
import '@prz-dp/ui-next/dist/ui.css';
import 'izitoast/dist/css/iziToast.min.css';

import { IKitThemes, KitPlugin } from '@prz-dp/ui-next';
import Vue from 'vue';

/**
 * Use `KitPlugin`.
 */
Vue.use(KitPlugin, {
  components: {},
  theme: IKitThemes.BASE,
  vuetifyVersion: 2
});
